import React from 'react'

const SvgFigure = props => (
  <svg width="1em" height="1em" viewBox="0 0 29 32" {...props}>
    <path
      fill={props.fill}
      fillRule="evenodd"
      d="M5.273 29.333h21.091V2.667H2.636v26.666h2.637zM27.682 0C28.407 0 29 .6 29 1.333v29.334A1.33 1.33 0 0 1 27.682 32H1.318C.592 32 0 31.4 0 30.667V1.333C0 .6.592 0 1.318 0h26.364zM14.5 17.333c-3.636 0-6.59 2.991-6.59 6.667h13.18c0-3.676-2.957-6.667-6.59-6.667zM11.864 12c0 1.47 1.18 2.667 2.636 2.667 1.455 0 2.636-1.196 2.636-2.667 0-1.47-1.18-2.667-2.636-2.667-1.455 0-2.636 1.196-2.636 2.667zm11.863 12v1.333a1.33 1.33 0 0 1-1.318 1.334H6.591a1.33 1.33 0 0 1-1.318-1.334V24a9.33 9.33 0 0 1 5.32-8.447A5.323 5.323 0 0 1 9.227 12c0-2.945 2.361-5.333 5.273-5.333 2.912 0 5.273 2.388 5.273 5.333 0 1.37-.526 2.61-1.367 3.553A9.33 9.33 0 0 1 23.727 24z"
    />
  </svg>
)

export default SvgFigure
